export class ClientDocs {
    id: number
    client_id: number
    client_file: string
    doc_type: string
    file_description: string
    
    public constructor(init?: Partial<ClientDocs>){
        Object.assign(this,init);
    }
}
